export const createElem = (type: string, parent: HTMLElement, className: string, innerHtml?: string) => {
    const elem = document.createElement(type);
    elem.className = className;
    if (innerHtml) {
        elem.innerHTML = innerHtml;
    }

    parent.appendChild(elem);
    return elem;
}

export const createDiv = (parent: HTMLElement, className: string, innerHtml?: string) => {
    return createElem("div", parent, className, innerHtml);
}

export const getOneByClass = (className: string, parentDiv?: HTMLElement): HTMLElement => {
    var byClass;
    if (parentDiv) {
        byClass = parentDiv.getElementsByClassName(className);
    }
    else {
        byClass = document.getElementsByClassName(className);
    }
    
    if (byClass.length != 1) {
        throw new Error(`Couldn't find 1 ${className}`!);
    }
    return byClass[0] as HTMLElement;
}

export function padNum(n, width) {
    var z = '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  export const delay = ms => new Promise(res => setTimeout(res, ms));

  export function scrollToElement(scrollToId: string, scrollable: HTMLElement, pad: number = 0){
    var topPos = document.getElementById(scrollToId).offsetTop;
    scrollable.scrollTop = topPos + pad;
  }